import { Button } from "@/src/components/buttons";
import Loading from "@/src/components/loading";
import { NotificationType, Patient, User } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId, jsonAbstract } from "@/src/utils/utils";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

export async function sendSimpleNotification({
  type,
  item,
  targetUsers,
  serviceId,
  shouldSendPush,
  shouldSendEmail,
}: {
  item: any;
  type: NotificationType;
  targetUsers?: (User | string)[];
  serviceId?: string | null | undefined;
  shouldSendPush?: boolean;
  shouldSendEmail?: boolean;
}) {
  await apiFetch("notifications", "addOne", {
    shouldSendEmail,
    shouldSendPush,
    notification: {
      type,
      status: "pending",
      creator: getUserId(),
      item: getItemId(item),
      service: jsonAbstract(serviceId),
      targetUsers: jsonAbstract(targetUsers || [item.creator]),
      patient: getItemId(item.patient),
      readBy: [],
    },
  });
}

export async function notifySubscribers({ itemId }: { itemId: any }) {
  await apiFetch("notifications", "notifyItemSubscribers", {
    creatorId: getUserId(),
    itemId: jsonAbstract(itemId),
  });
}

export function SubscribeToItemButton({
  item,
  patient,
}: {
  item: any;
  patient: Patient;
}) {
  const [reload, setReload] = useState(0);
  let { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["SubscribeToItemButton", item?.id, patient?.id],
    queryFn: async () =>
      apiFetch(
        "notifications",
        "checkIfSubscribedToItem",
        {
          itemId: jsonAbstract(item.id),
          userId: getUserId(),
        },
        "Erreur lors du chargement"
      ),
  });

  if (isLoading)
    return (
      <Button onClick={async () => {}}>
        <Loading></Loading>
      </Button>
    );

  if (data?.isSubscribed)
    return (
      <Button onClick={async () => {}} isDisabled={true}>
        Déjà abonné aux modifications
      </Button>
    );

  return (
    <Button
      onClick={async () => {
        let result = await apiFetch("notifications", "subscribeToItem", {
          itemId: jsonAbstract(item.id),
          userId: getUserId(),
          patientId: jsonAbstract(patient?.id || patient),
        });
        console.log("result", result);
        setReload((prev) => prev + 1);
      }}
    >
      Être notifié en cas de changement
    </Button>
  );
}
